import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'button[data-component-type=button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent implements OnInit {

  @Input() buttonType$!: Observable<ButtonType>
  @Input() url$!: Observable<string>
  @Input() content$!: Observable<string>

  constructor() { }

  ngOnInit(): void {
  }

}

export type ButtonType = {
  [key in func | color]?: boolean;
};

export type func = 'next' | 'back'
export type color = 'normal' | 'info' | 'success' | 'loading'
